<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical headerTitle="Select Customer" >
          <template v-slot:body>
            <v-layout column overflow-auto>
              <v-row no-gutters>
                <v-col cols="auto" class="pa-6 pb-0 pt-1 pr-2 header" >
                  Current Customer
                </v-col>
                <v-col cols="full">
                  <v-text-field 
                    dense 
                    outlined 
                    hide-details="auto"
                    clearable
                    readonly
                    v-model="currentCustomer"
                  />
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" class="pa-0">
                  <i-card-top
                    class="d-md-flex"
                    outlined
                    :useBtnList="[
                      'btnRetrieve', //Retrieve
                    ]"
                    @btnRetrieve="btnRetrieve()"
                  >
                    <template v-slot:body>
                      <v-layout column>
                        <v-row no-gutters class="center pa-2 pb-0">
                          <v-icon small color="blue">mdi-circle</v-icon>
                          <span class="pa-1 subTitle">Customer Code: </span>
                          <v-col cols="2">
                            <v-text-field 
                              dense 
                              outlined 
                              hide-details="auto"
                              clearable
                              v-model="customerCode"
                              @keydown.enter="btnRetrieve()"
                            />
                          </v-col>
                          <v-icon small color="blue" class="pl-2">mdi-circle</v-icon>
                          <span class="pa-1 subTitle"> Customer Name: </span>
                          <v-col cols="2">
                            <v-text-field class="popField" 
                              dense 
                              outlined 
                              hide-details="auto"
                              clearable 
                              v-model="customerName"
                              @keydown.enter="btnRetrieve()"
                            />
                          </v-col>
                          <v-icon small color="blue" class="pl-2">mdi-circle</v-icon>
                          <span class="pa-1 subTitle"> Use Div: </span>
                          <v-col cols="1">
                            <v-select
                              v-model="useDiv"
                              :items="useDivList"
                              item-value="sysCode"
                              label="Select No"
                              return-object
                              single-line
                              clearable
                              outlined
                              dense
                            ></v-select>
                          </v-col>
                        </v-row>
                      </v-layout>
                    </template>
                  </i-card-top>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" class="pa-0">
                  <v-row no-gutters>
                    <v-col cols="12" align="right" class="pr-2 customer">* Click customer code.</v-col>
                  </v-row>
                  <DxDataGrid id="epmsZ010" 
                    class="hipGridHeight2" 
                    :ref="epmsZ010Ref"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    @cellPrepared="cellPrepared"
                  >
                    <DxColumn data-field="rnum" caption="NO" width="3%" data-type="string" alignment="center" :visible="true" />
                    <DxColumn data-field="custCd" caption="Code" width="7%" data-type="string" alignment="center" cell-template="custCdTemplate" />
                      <template #custCdTemplate="{ data }">
                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 custCdBtn" @click="custCdBtn(data)">
                          {{data.text}}
                        </v-btn>
                      </template>
                    <DxColumn data-field="custNm" caption="Customer Name" width="27%" data-type="string" alignment="left" :allow-editing="true" />
                    <DxColumn data-field="custNo" caption="Ref. No" width="10%" data-type="string" alignment="center" :allow-editing="true" />
                    <DxColumn data-field="represent" caption="Represent" width="10%" data-type="string" alignment="center" :allow-editing="true" />
                    <DxColumn data-field="tel" caption="Tel" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="fax" caption="Fax" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="addr" caption="Address" width="20%" data-type="string" alignment="left" :allow-editing="false" />
                    <DxColumn data-field="useDiv" caption="Use" width="3%" data-type="string" alignment="center" :allow-editing="false" />

                    <DxPaging :enabled="true" :page-size="30" />
                    <DxScrolling column-rendering-mode="virtual" />
                  </DxDataGrid>
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn , DxButton , DxScrolling } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import notify from 'devextreme/ui/notify' // message
import { getCustomerList } from '@/api/view/mis/Z/epmsZ010.js'

export default {
  name: 'epms4000',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxDateBox,
    DxButton,
    DxScrolling
  },
  data() {
    return {
      useDivList: ['Y', 'N'],

      epmsZ010Ref: 'epmsZ010Ref',
      gridMainList: [],

      custCd: '',
      custNm: '',
      currentCustomer: '',

      //Retrieve text input
      customerCode: '',
      customerName: '',
      useDiv: '',

    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.epmsZ010Ref)
    },
  },
  mounted(){
    // console.log('makerCd: ', this.$store.state.user.makerCd)
    this.doSearchMain()
  },
  methods: {
    btnRetrieve(){
      if(this.customerCode === null){
        this.customerCode = ''
      } else if(this.customerName === null){
        this.customerName = ''
      } else if(this.useDiv === null){
        this.useDiv = ''
      }
      this.doSearchMain()
    },
    async doSearchMain(){
      this.openLoading('searching')
      let params = {
        custCd: this.customerCode,
        custNm: this.customerName,
        useDiv: this.useDiv
      }
      await getCustomerList(params).then(res => {
        console.log(" RES : " , res)
        this.gridMainList = res.list
        res.list.forEach(e => {
          if(e.custCd == this.$store.state.user.makerCd){
            this.custNm = e.custNm
          }
        });
        this.currentCustomer = this.$store.state.user.makerCd + ' - ' + this.custNm
      }).finally(() => {
        this.endLoading()
      })

    },
    cellPrepared(e){
      if(e.rowType === 'data'){
        e.cellElement.style.padding = '1px'
      }
    },
    custCdBtn(e){
      this.vToastify(this.$t('Do you want to change customer?'), 'warn')
    }
  }
}
</script>
<style scoped>
  .subTitle {
    font-weight: bold;
    color: black;
  }
  .customer {
    color: red;
    font-weight: bold;
  }
  .header {
    border: 1px solid gray;
    background-color: rgb(223,227,213);
    color: black;
  }
  .custCdBtn {
    font-weight: bold;
  }
  .custCdBtn:hover {
    color: #4980BC;
  }
</style>